import { useAuth } from 'react-oidc-context';

/**
 * A hook that provides a logout function for signing out the user.
 * The returned function triggers the signout redirect process using the authentication provider.
 *
 * @return A function that, when invoked, initiates the signout redirect process.
 */
export function useLogout() {
  const auth = useAuth();

  return () => {
    void auth.signoutRedirect();
  };
}
